<template>
  <div>
    <b-row>
      <b-col>
        <router-link :to="{ name: 'FinancialReportList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
      </b-col>
    </b-row>
    <Loader v-if="isLoading"></Loader>
    <b-row v-else>
      <b-col v-if="item['EXCMCases'].length > 0" cols="12">
        <b-card>
          <div class="h6">
            {{$t('menu.cases.index')}} - {{$t('views.exsbinvoices.list.title')}}
          </div>
          {{item.name}}
          <hr class="mt-1 mb-1">
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th>{{$t('views.exsbinvoices.list.number')}}</th>
              <th>{{$t('views.exsbinvoices.form.documentType')}}</th>
              <th>{{$t('views.exsbinvoices.list.issueDate')}}</th>
              <th>{{$t('views.exsbinvoices.list.totalPurchaseValueNetto')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item['EXCMCases']" :key="item.id">
              <td>
                <router-link :to="{ name: 'EXSBInvoiceShow', params: {id: getInvoiceIRI(item.id)} }">
                  {{item.number}}
                </router-link>
              </td>
              <td>{{invoiceDocumentType[item.invoiceDocumentType]}}</td>
              <td>{{$moment(item.issueDate.date).format('YYYY-MM-DD')}}</td>
              <td>{{getTotalPurchaseValueNettoPerInvoice(item.positions)}}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
      <b-col v-if="item['EXSBOrders'].length > 0" cols="12">
        <b-card>
          <div class="h6">
            {{$t('routes.EXSBOrderList')}} - {{$t('views.exsbinvoices.list.title')}}
          </div>
          {{item.name}}
          <hr class="mt-1 mb-1">
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th>{{$t('views.exsbinvoices.list.number')}}</th>
              <th>{{$t('views.exsbinvoices.form.documentType')}}</th>
              <th>{{$t('views.exsbinvoices.list.issueDate')}}</th>
              <th>{{$t('views.exsbinvoices.list.totalPurchaseValueNetto')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item['EXSBOrders']" :key="item.id">
              <td>
                <router-link :to="{ name: 'EXSBInvoiceShow', params: {id: getInvoiceIRI(item.id)} }">
                  {{item.number}}
                </router-link>
              </td>
              <td>{{invoiceDocumentType[item.invoiceDocumentType]}}</td>
              <td>{{$moment(item.issueDate.date).format('YYYY-MM-DD')}}</td>
              <td>{{getTotalPurchaseValueNettoPerInvoice(item.positions)}}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
      <b-col v-if="item['EXCMAgreements'].length > 0" cols="12">
        <b-card>
          <div class="h6">
            {{$t('routes.EXCMAgreementList')}} - {{$t('views.exsbinvoices.list.title')}}
          </div>
          {{item.name}}
          <hr class="mt-1 mb-1">
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th>{{$t('views.exsbinvoices.list.number')}}</th>
              <th>{{$t('views.exsbinvoices.form.documentType')}}</th>
              <th>{{$t('views.exsbinvoices.list.issueDate')}}</th>
              <th>{{$t('views.exsbinvoices.list.totalPurchaseValueNetto')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item['EXCMAgreements']" :key="item.id">
              <td>
                <router-link :to="{ name: 'EXSBInvoiceShow', params: {id: getInvoiceIRI(item.id)} }">
                  {{item.number}}
                </router-link>
              </td>
              <td>{{invoiceDocumentType[item.invoiceDocumentType]}}</td>
              <td>{{$moment(item.issueDate.date).format('YYYY-MM-DD')}}</td>
              <td>{{getTotalPurchaseValueNettoPerInvoice(item.positions)}}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
      <b-col v-if="item['Other'].length > 0" cols="12">
        <b-card>
          <div class="h6">
            {{$t('views.financialreport.show.other')}} - {{$t('views.exsbinvoices.list.title')}}
          </div>
          {{item.name}}
          <hr class="mt-1 mb-1">
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th>{{$t('views.exsbinvoices.list.number')}}</th>
              <th>{{$t('views.exsbinvoices.form.documentType')}}</th>
              <th>{{$t('views.exsbinvoices.list.issueDate')}}</th>
              <th>{{$t('views.exsbinvoices.list.totalPurchaseValueNetto')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item['Other']" :key="item.id">
              <td>
                <router-link :to="{ name: 'EXSBInvoiceShow', params: {id: getInvoiceIRI(item.id)} }">
                  {{item.number}}
                </router-link>
              </td>
              <td>{{invoiceDocumentType[item.invoiceDocumentType]}}</td>
              <td>{{$moment(item.issueDate.date).format('YYYY-MM-DD')}}</td>
              <td>{{getTotalPurchaseValueNettoPerInvoice(item.positions)}}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card>
          <div class="h6">
            {{$t('views.financialreport.show.balance')}}
            <hr class="mt-1 mb-1">
          </div>
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th> </th>
              <th>{{$t('views.financialreport.show.sum')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{$t('menu.cases.index')}}</td>
              <td>{{getTotalPurchaseValueNetto(item.EXCMCases)}}</td>
            </tr>
            <tr>
              <td>{{$t('routes.EXSBOrderList')}}</td>
              <td>{{getTotalPurchaseValueNetto(item.EXSBOrders)}}</td>
            </tr>
            <tr>
              <td>{{$t('routes.EXCMAgreementList')}}</td>
              <td>{{getTotalPurchaseValueNetto(item.EXCMAgreements)}}</td>
            </tr>
            <tr>
              <td>{{$t('views.financialreport.show.other')}}</td>
              <td>{{getTotalPurchaseValueNetto(item.Other)}}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ENTRYPOINT } from '@/config/entrypoint'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'Show',
  computed: {
    ...mapGetters({
      item: 'financialreport/show/item',
      isLoading: 'financialreport/show/isLoading'
    })
  },
  components: {
    Loader
  },
  created () {
    this.getItem(this.$route.params.id)
  },
  data () {
    return {
      invoiceDocumentType: {
        1: this.$t('views.exsbinvoices.form.salesInvoice'),
        2: this.$t('views.exsbinvoices.form.purchaseInvoice')
      }
    }
  },
  methods: {
    getInvoiceIRI (id) {
      let url = new URL(ENTRYPOINT)
      return url.pathname + 'e_x_s_b_invoices/' + id
    },
    getTotalPurchaseValueNetto (item) {
      if (item.length < 1) return 0
      return Math.round(item.map(invoice => {
        let result = this.getTotalPurchaseValueNettoPerInvoice(invoice.positions)
        if (invoice.invoiceDocumentType === 2) return result * (-1) // jeśli faktura zakupowa
        else return result
      }).reduce((previous, current) => previous + current) * 100) / 100
    },
    getTotalPurchaseValueNettoPerInvoice (positions) {
      let result = 0
      positions.forEach(position => {
        if (position.purchasePriceNettoPerUnit) result += position.purchasePriceNettoPerUnit * position.quantity
        else result += position.priceNettoPerUnit * position.quantity
      })
      return result
    },
    ...mapActions({
      getItem: 'financialreport/show/getItem'
    })
  }
}
</script>

<style scoped>

</style>
